// src/components/EventCashCoin.js
import React from 'react';

export default function EventCashCoin() {
  return (
    <div className="max-w-3xl mx-auto bg-white rounded-xl shadow p-6 mt-8">
      <h2 className="text-2xl font-bold text-orange-600 mb-4">🎉 EVENT BERHADIAH CASH COIN RF FUN SERVER! 🎉</h2>
      <p className="mb-4 text-lg font-semibold text-gray-800">💰 Dapatkan <span className="text-green-600 font-bold">100.000 Cash Coin</span> secara langsung!</p>

      <h3 className="font-semibold text-lg mb-2">✅ Cara Ikut Event:</h3>
      <ul className="list-decimal pl-6 text-gray-700 space-y-2 mb-4">
        <li>
          Follow YouTube: <a href="https://www.youtube.com/@RFFUNSERVER" className="text-blue-600 underline" target="_blank" rel="noreferrer">RF FUN SERVER</a>
        </li>
        <li>
          Follow YouTube: <a href="https://www.youtube.com/@ALFATHARS" className="text-blue-600 underline" target="_blank" rel="noreferrer">ALFATHARS</a>
        </li>
        <li>
          Comment kesan bermain + Nick RF FUN SERVER kamu di video YouTube:{" "}
          <a href="https://youtu.be/1qafMwmzYgM" className="text-blue-600 underline" target="_blank" rel="noreferrer">
            https://youtu.be/1qafMwmzYgM
          </a>
        </li>
        <li>
          Comment kesan bermain + Nick RF FUN SERVER kamu di Instagram reel:{" "}
          <a href="https://www.instagram.com/reel/DK9mGbZSAni/" className="text-blue-600 underline" target="_blank" rel="noreferrer">
            https://www.instagram.com/reel/DK9mGbZSAni/
          </a>
        </li>
      </ul>

      <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 mb-4">
        <p className="font-semibold">🎁 BONUS SPESIAL:</p>
        <p>🏆 <strong>GRAND REWARD untuk Best Comment Mingguan:</strong> 500.000 Cash Coin!</p>
      </div>

      <h3 className="font-semibold text-lg mb-2">📩 Cara Klaim Hadiah:</h3>
      <p className="text-gray-700 mb-2">
        Kirimkan bukti lengkap (screenshot) ke <strong>GM FLUX</strong> melalui Discord:
      </p>
      <a
        href="https://discord.gg/qFsPTq2Nwr"
        className="inline-block bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 mb-4"
        target="_blank"
        rel="noreferrer"
      >
        Join Discord Server
      </a>

      <ul className="list-disc pl-6 text-gray-700 space-y-1">
        <li>SS subscribe YouTube RF FUN SERVER</li>
        <li>SS subscribe YouTube ALFATHARS</li>
        <li>SS comment di postingan YouTube</li>
        <li>SS comment di postingan Instagram</li>
      </ul>

      <p className="mt-6 font-semibold text-center text-orange-600">
        RF FUN SERVER – Tempat Nostalgia dan Petualangan Panjangmu Dimulai!
      </p>
    </div>
  );
}
